/* Formichetti HD — script del tema. Vanilla JS, nessuna dipendenza.
   Moduli: tema chiaro/scuro, orologi, header su hero, overlay (focus trap), carrello (Cart AJAX + Section Rendering),
   size selector e quick add, notify me, request info, ricerca predittiva, toast. Le sezioni aggiungono i propri moduli in fondo. */
(function () {
  'use strict';
  var HD = window.HD || (window.HD = {});
  var doc = document;
  var root = doc.documentElement;
  var reduce = function () { return !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches); };
  var $ = function (s, el) { return (el || doc).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || doc).querySelectorAll(s)); };
  var on = function (el, ev, fn, opt) { if (el) el.addEventListener(ev, fn, opt); };
  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  HD.$ = $; HD.$$ = $$; HD.reduce = reduce; HD.EMAIL = EMAIL;

  /* ---------- Prezzi: stesso formato di Shopify (shop.money_format), es. "{{amount_no_decimals_with_comma_separator}} €" ---------- */
  HD.money = function (cents) {
    if (HD.currency === 'CHF') {
      var v = Math.abs(Number(cents)) / 100, w = Math.floor(v), f = Math.round((v - w) * 100);
      return (cents < 0 ? '\u2212' : '') + String(w).replace(/\B(?=(\d{3})+(?!\d))/g, "'") + (f ? '.' + String(f).padStart(2, '0') : '') + ' CHF';
    }
    var fmt = HD.moneyFormat || '{{amount}} €';
    var n = Number(cents) / 100;
    var group = function (num, dec, th, ds) {
      var p = num.toFixed(dec).split('.');
      return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th) + (p[1] ? ds + p[1] : '');
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return group(n, 0, HD.currency === 'CHF' ? "'" : HD.currency === 'EUR' ? '.' : ',', '.');
        case 'amount_with_comma_separator': return group(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(n, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return group(n, 2, "'", '.');
        default: return group(n, 2, ',', '.');
      }
    });
  };

  /* ---------- Tema: Auto / Light / Dark ---------- */
  var effTheme = function () {
    var t = root.dataset.theme;
    if (t === 'light' || t === 'dark') return t;
    return window.matchMedia && matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  };
  var themeDefault = (window.HD && HD.themeDefault) || 'system';
  var isMode = function (t) { return t === 'light' || t === 'dark' || t === 'system'; };
  var stored = function () { try { var t = localStorage.getItem('hd-theme'); return isMode(t) ? t : themeDefault; } catch (e) { return themeDefault; } };
  var setTheme = function (v) {
    try { localStorage.setItem('hd-theme', v); } catch (e) {}
    root.dataset.theme = v;
    syncTheme();
  };
  var syncTheme = function () {
    var cur = stored();
    $$('[data-hd-theme]').forEach(function (g) {
      $$('.hd-theme__opt', g).forEach(function (b) {
        var sel = b.dataset.value === cur;
        b.setAttribute('aria-checked', sel ? 'true' : 'false');
        b.tabIndex = sel ? 0 : -1;
      });
    });
    var dark = effTheme() === 'dark';
    $$('[data-hd-theme-flip]').forEach(function (b) {
      b.setAttribute('aria-label', dark ? 'Switch to light mode' : 'Switch to dark mode');
      var i = $('.hd-icon', b);
      if (i) i.className = 'hd-icon hd-icon--' + (dark ? 'sun' : 'moon');
    });
  };
  on(doc, 'click', function (e) {
    var opt = e.target.closest('[data-hd-theme] .hd-theme__opt');
    if (opt) setTheme(opt.dataset.value);
    if (e.target.closest('[data-hd-theme-flip]')) setTheme(effTheme() === 'dark' ? 'light' : 'dark');
  });
  on(doc, 'keydown', function (e) {
    var opt = e.target.closest && e.target.closest('[data-hd-theme] .hd-theme__opt');
    if (!opt) return;
    var opts = $$('.hd-theme__opt', opt.parentNode);
    var i = opts.indexOf(opt), j = null;
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') j = (i + 1) % opts.length;
    if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') j = (i + opts.length - 1) % opts.length;
    if (j === null) return;
    e.preventDefault();
    setTheme(opts[j].dataset.value);
    opts[j].focus();
  });
  if (window.matchMedia) {
    var mq = matchMedia('(prefers-color-scheme: dark)');
    if (mq.addEventListener) mq.addEventListener('change', syncTheme);
  }

  /* ---------- Orologi delle città ---------- */
  var tick = function () {
    var now = new Date();
    $$('[data-hd-clocks] time[data-tz]').forEach(function (t) {
      try { t.textContent = new Intl.DateTimeFormat('en-GB', { hour: '2-digit', minute: '2-digit', hourCycle: 'h23', timeZone: t.dataset.tz }).format(now); } catch (e) { t.textContent = '--:--'; }
    });
  };

  /* ---------- Header scuro sopra l'hero (IntersectionObserver, nessuno scroll listener) ---------- */
  var heroHeader = function () {
    var hero = $('[data-hd-hero-dark]');
    var header = $('[data-hd-header]');
    var bar = $('[data-hd-announce]');
    if (!hero || !header || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      var dark = es[0].isIntersecting;
      header.classList.toggle('hd-scheme-dark', dark);
      header.classList.toggle('sh-ink', dark);
      if (bar) {
        var base = bar.dataset.scheme;
        if (base) bar.classList.toggle(base, !dark);
        bar.classList.toggle('hd-scheme-light', dark);
      }
    }, { rootMargin: '-64px 0px 0px 0px' });
    io.observe(hero);
  };

  /* ---------- Overlay: drawer e modali con focus trap, Esc, scrim ---------- */
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  var stack = [];
  var visible = function (el) { return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length); };
  HD.open = function (id, opener) {
    var ov = doc.getElementById(id);
    if (!ov || !ov.hidden) return ov;
    ov.hidden = false;
    stack.push({ ov: ov, prev: opener || doc.activeElement });
    doc.body.style.overflow = 'hidden';
    $$('[aria-controls="' + id + '"]').forEach(function (b) { if (b.hasAttribute('aria-expanded')) b.setAttribute('aria-expanded', 'true'); });
    var first = $('[autofocus]', ov) || $$(FOCUSABLE, ov).filter(visible)[0];
    if (first) first.focus({ preventScroll: true });
    ov.dispatchEvent(new CustomEvent('hd:open'));
    return ov;
  };
  HD.close = function (id) {
    var i = -1;
    for (var k = stack.length - 1; k >= 0; k--) if (!id || stack[k].ov.id === id) { i = k; break; }
    if (i < 0) return;
    var s = stack.splice(i, 1)[0];
    s.ov.hidden = true;
    $$('[aria-controls="' + s.ov.id + '"]').forEach(function (b) { if (b.hasAttribute('aria-expanded')) b.setAttribute('aria-expanded', 'false'); });
    if (!stack.length) doc.body.style.overflow = '';
    if (s.prev && s.prev.focus && doc.contains(s.prev)) s.prev.focus({ preventScroll: true });
    s.ov.dispatchEvent(new CustomEvent('hd:close'));
  };
  on(doc, 'click', function (e) {
    var op = e.target.closest('[data-hd-open]');
    if (op) {
      e.preventDefault();
      if (op.dataset.hdOpen === 'hd-cart') HD.close('hd-menu');
      HD.open(op.dataset.hdOpen, op);
      return;
    }
    if (e.target.closest('[data-hd-close]')) { var ov = e.target.closest('[data-hd-overlay]'); HD.close(ov && ov.id); return; }
    if (e.target.matches && e.target.matches('[data-hd-overlay]')) HD.close(e.target.id);
  });
  on(doc, 'keydown', function (e) {
    if (!stack.length) return;
    var ov = stack[stack.length - 1].ov;
    if (e.key === 'Escape') { e.preventDefault(); HD.close(ov.id); return; }
    if (e.key !== 'Tab') return;
    var f = $$(FOCUSABLE, ov).filter(visible);
    if (!f.length) return;
    var a = f[0], z = f[f.length - 1];
    if (e.shiftKey && doc.activeElement === a) { e.preventDefault(); z.focus(); }
    else if (!e.shiftKey && doc.activeElement === z) { e.preventDefault(); a.focus(); }
  });

  /* ---------- Toast ---------- */
  HD.toast = function (msg, tone) {
    var reg = $('[data-hd-toasts]');
    if (!reg) return;
    var t = doc.createElement('div');
    tone = tone || 'success';
    t.className = 'hd-toast hd-toast--' + tone;
    t.setAttribute('role', tone === 'error' ? 'alert' : 'status');
    t.innerHTML = '<span class="hd-icon hd-icon--' + ({ success: 'check', info: 'info', error: 'alert' }[tone]) + ' hd-toast__icon" aria-hidden="true"></span><p class="hd-toast__msg"></p>';
    $('.hd-toast__msg', t).textContent = msg;
    reg.appendChild(t);
    setTimeout(function () { t.remove(); }, 4000);
  };

  /* ---------- Carrello ---------- */
  var cartSection = 'cart-drawer';
  var renderCart = function (html, keepOpen) {
    var tmp = doc.createElement('div');
    tmp.innerHTML = html;
    var next = $('[data-hd-cart-inner]', tmp);
    var cur = $('[data-hd-cart-inner]');
    if (next && cur) {
      var focusSel = doc.activeElement && cur.contains(doc.activeElement) ? focusKey(doc.activeElement) : null;
      cur.innerHTML = next.innerHTML;
      if (focusSel) { var f = $(focusSel, cur) || $('.hd-iconbtn', cur); if (f) f.focus({ preventScroll: true }); }
    }
  };
  var focusKey = function (el) {
    var line = el.closest('[data-key]');
    if (line && el.dataset.hdQty) {
      var q = Number(el.dataset.hdQty);
      var lineQty = Number(($('.hd-qty__val', line) || {}).textContent || 0);
      return '[data-key="' + line.dataset.key + '"] .hd-qty__btn[aria-label="' + (q > lineQty ? 'Increase' : 'Decrease') + ' quantity"]';
    }
    return null;
  };
  var setCount = function (n) {
    $$('[data-hd-bag]').forEach(function (b) {
      b.setAttribute('aria-label', n > 0 ? 'Bag, ' + n + (n === 1 ? ' item' : ' items') : 'Bag');
      var c = $('[data-hd-bag-count]', b);
      if (c) { c.hidden = n === 0; c.innerHTML = '<i class="hd-dot"></i>' + n; }
    });
  };
  var post = function (url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  };
  HD.cartAdd = function (items) {
    return post(HD.routes.cartAdd + '.js', { items: items, sections: cartSection, sections_url: location.pathname })
      .then(function (j) {
        if (j.sections && j.sections[cartSection]) renderCart(j.sections[cartSection]);
        return fetch(HD.routes.cart + '.js').then(function (r) { return r.json(); });
      })
      .then(function (c) { setCount(c.item_count); return c; });
  };
  HD.cartChange = function (key, qty) {
    return post(HD.routes.cartChange + '.js', { id: key, quantity: qty, sections: cartSection, sections_url: location.pathname })
      .then(function (j) {
        if (j.sections && j.sections[cartSection]) renderCart(j.sections[cartSection]);
        setCount(j.item_count);
        return j;
      });
  };
  HD.openCart = function () { HD.open('hd-cart'); };
  on(doc, 'click', function (e) {
    var q = e.target.closest('#hd-cart [data-hd-qty]');
    if (q) {
      var line = q.closest('[data-key]');
      q.disabled = true;
      HD.cartChange(line.dataset.key, Number(q.dataset.hdQty)).catch(function (err) {
        q.disabled = false;
        HD.toast((err && err.description) || 'Something went wrong on our side. Try again in a minute.', 'error');
      });
      return;
    }
    var opt = e.target.closest('[data-hd-upsell] .hd-size');
    if (opt) {
      var box = opt.closest('[data-hd-upsell]');
      $$('.hd-size', box).forEach(function (b) { var s = b === opt; b.setAttribute('aria-checked', s); b.tabIndex = s ? 0 : -1; });
      var add = $('[data-hd-upsell-add]', box);
      add.dataset.hdUpsellAdd = opt.dataset.variant;
      $('.hd-btn__meta', add).textContent = opt.dataset.price;
      return;
    }
    var ua = e.target.closest('[data-hd-upsell-add]');
    if (ua) {
      busy(ua, 'Adding');
      HD.cartAdd([{ id: Number(ua.dataset.hdUpsellAdd), quantity: 1 }]).catch(function (err) {
        idle(ua);
        HD.toast((err && err.description) || 'Something went wrong on our side. Try again in a minute.', 'error');
      });
    }
  });

  /* Stati del bottone d'acquisto: Add to bag → Adding → Added to bag (stessa etichetta, prezzo sempre a destra). */
  var busy = function (btn, label) {
    var l = $('.hd-btn__label', btn);
    if (!btn.dataset.label) btn.dataset.label = l.innerHTML;
    btn.setAttribute('aria-busy', 'true');
    l.innerHTML = label + '<span class="hd-btn__caret" aria-hidden="true"></span>';
  };
  var idle = function (btn) {
    btn.removeAttribute('aria-busy');
    if (btn.dataset.label) $('.hd-btn__label', btn).innerHTML = btn.dataset.label;
  };
  var added = function (btn, label) {
    btn.removeAttribute('aria-busy');
    btn.classList.remove('hd-btn--primary');
    btn.classList.add('hd-btn--secondary');
    $('.hd-btn__label', btn).innerHTML = '<span class="hd-icon hd-icon--check" aria-hidden="true"></span>' + label;
    var live = btn.parentNode && $('.hd-vh[aria-live]', btn.parentNode);
    if (live) live.textContent = label;
    setTimeout(function () {
      btn.classList.add('hd-btn--primary');
      btn.classList.remove('hd-btn--secondary');
      idle(btn);
      if (live) live.textContent = '';
    }, 2400);
  };
  HD.btn = { busy: busy, idle: idle, added: added };

  /* Bottoni Add to bag generici: data-hd-add="<variant id>" (sezioni prodotto, finish strip, barra sticky). */
  on(doc, 'click', function (e) {
    var b = e.target.closest('[data-hd-add]');
    if (!b || b.getAttribute('aria-busy') === 'true' || b.disabled) return;
    e.preventDefault();
    var id = Number(b.dataset.hdAdd);
    if (!id) return;
    busy(b, 'Adding');
    HD.cartAdd([{ id: id, quantity: 1 }])
      .then(function () { added(b, b.dataset.addedLabel || 'Added to bag'); HD.openCart(); })
      .catch(function (err) { idle(b); HD.toast((err && err.description) || 'Something went wrong on our side. Try again in a minute.', 'error'); });
  });

  /* ---------- Size selector (card merch, pagina prodotto, notify me) ---------- */
  HD.stockNote = function (stock, size) {
    if (stock === 1) return 'Last one in ' + size;
    if (stock === 2 || stock === 3) return 'Only ' + stock + ' left in ' + size;
    if (stock === 0) return size + ' is sold out.';
    return '';
  };
  var pickSize = function (btn, focus) {
    var group = btn.closest('.hd-sizes');
    $$('.hd-size', group).forEach(function (b) { var s = b === btn; b.setAttribute('aria-checked', s ? 'true' : 'false'); b.tabIndex = s ? 0 : -1; });
    if (focus) btn.focus();
    group.dispatchEvent(new CustomEvent('hd:size', { bubbles: true, detail: { btn: btn } }));
  };
  on(doc, 'click', function (e) {
    var b = e.target.closest('.hd-sizes .hd-size');
    if (b && !b.closest('[data-hd-upsell]')) pickSize(b);
  });
  on(doc, 'keydown', function (e) {
    var b = e.target.closest && e.target.closest('.hd-sizes .hd-size');
    if (!b) return;
    var all = $$('.hd-size', b.closest('.hd-sizes'));
    var i = all.indexOf(b), j = null;
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') j = (i + 1) % all.length;
    if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') j = (i - 1 + all.length) % all.length;
    if (j === null) return;
    e.preventDefault();
    if (b.closest('[data-hd-upsell]')) { all[j].click(); all[j].focus(); } else pickSize(all[j], true);
  });

  /* ---------- Card merch: quick add in due tap ---------- */
  var cardCta = function (card) {
    var sel = $('.hd-size[aria-checked="true"]', card);
    var btn = $('[data-hd-card-cta]', card);
    var note = $('.hd-stock', card);
    var price = card.dataset.price;
    var allOut = card.classList.contains('hd-pcard--soldout');
    var html, cls = 'hd-btn hd-btn--compact hd-btn--block ', meta = '';
    btn.removeAttribute('aria-busy');
    btn.disabled = false;
    delete btn.dataset.label;
    if (!sel && allOut) { cls += 'hd-btn--secondary'; html = '<span class="hd-icon hd-icon--bell" aria-hidden="true"></span>Notify me'; btn.dataset.mode = 'notify'; }
    else if (!sel) { cls += 'hd-btn--secondary'; html = 'Select a size'; btn.disabled = true; btn.dataset.mode = ''; }
    else if (sel.dataset.stock !== '' && Number(sel.dataset.stock) === 0) { cls += 'hd-btn--secondary'; html = '<span class="hd-icon hd-icon--bell" aria-hidden="true"></span>Notify me, ' + sel.dataset.size; btn.dataset.mode = 'notify'; }
    else { cls += 'hd-btn--primary hd-btn--split'; html = 'Add ' + sel.dataset.size + ' to bag'; meta = '<span class="hd-btn__meta">' + price + '</span>'; btn.dataset.mode = 'add'; }
    btn.className = cls;
    btn.innerHTML = '<span class="hd-btn__label">' + html + '</span>' + meta;
    if (note) note.textContent = sel && sel.dataset.stock !== '' ? HD.stockNote(Number(sel.dataset.stock), sel.dataset.size) : '';
  };
  on(doc, 'hd:size', function (e) {
    var card = e.target.closest('[data-hd-merch-card]');
    if (card) cardCta(card);
  });
  on(doc, 'click', function (e) {
    var btn = e.target.closest('[data-hd-card-cta]');
    if (!btn || btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
    var card = btn.closest('[data-hd-merch-card]');
    var sel = $('.hd-size[aria-checked="true"]', card);
    if (btn.dataset.mode === 'notify') { HD.notify(card, sel ? sel.dataset.size : ''); return; }
    if (btn.dataset.mode !== 'add' || !sel) return;
    busy(btn, 'Adding');
    HD.cartAdd([{ id: Number(sel.dataset.variant), quantity: 1 }])
      .then(function () {
        btn.className = 'hd-btn hd-btn--compact hd-btn--block hd-btn--secondary hd-btn--split';
        btn.removeAttribute('aria-busy');
        btn.innerHTML = '<span class="hd-btn__label"><span class="hd-icon hd-icon--check" aria-hidden="true"></span>Added to bag, ' + sel.dataset.size + '</span><span class="hd-btn__meta">' + card.dataset.price + '</span>';
        btn.dataset.mode = '';
        HD.openCart();
        setTimeout(function () { cardCta(card); }, 2400);
      })
      .catch(function (err) { cardCta(card); HD.toast((err && err.description) || 'Something went wrong on our side. Try again in a minute.', 'error'); });
  });

  /* ---------- Notify me (merch esaurito): form contatti con tag notify-me, finché non c'è un'app back-in-stock ---------- */
  var ntf = { name: '', sizes: [] };
  HD.notify = function (src, size) {
    var ov = doc.getElementById('hd-notify');
    if (!ov) return;
    ntf.name = src.dataset.name;
    ntf.sizes = JSON.parse(src.dataset.sizes || '[]');
    var form = $('[data-hd-notify-form]', ov);
    form.hidden = false;
    form.reset();
    $('[data-hd-notify-done]', ov).hidden = true;
    $('[data-hd-notify-submit]', ov).hidden = false;
    $('[data-hd-notify-close]', ov).hidden = true;
    $('[data-hd-notify-title]', ov).textContent = 'Notify me';
    $('#hd-ntf-email-msg', ov).hidden = true;
    $('[data-hd-notify-size-err]', ov).hidden = true;
    var wrap = $('[data-hd-notify-sizes-wrap]', ov);
    var g = $('[data-hd-notify-sizes]', ov);
    wrap.hidden = ntf.sizes.length < 2;
    g.style.setProperty('--hd-size-count', ntf.sizes.length);
    g.innerHTML = ntf.sizes.map(function (s, i) {
      var sel = s.size === size;
      return '<button type="button" role="radio" class="hd-size' + (s.stock === 0 ? ' hd-size--out' : '') + '" aria-checked="' + sel + '" tabindex="' + (sel || (!size && i === 0) ? 0 : -1) + '" data-size="' + s.size + '">' + s.size + '</button>';
    }).join('');
    var lead = function () {
      var cur = $('.hd-size[aria-checked="true"]', g);
      $('[data-hd-notify-lead]', ov).textContent = ntf.name + (cur ? ' in ' + cur.dataset.size : '') + ' is sold out. We write once, when it’s back.';
    };
    lead();
    g.onclick = lead;
    HD.open('hd-notify');
  };
  on(doc, 'submit', function (e) {
    var form = e.target.closest('[data-hd-notify-form]');
    if (!form) return;
    e.preventDefault();
    var ov = form.closest('[data-hd-overlay]');
    var g = $('[data-hd-notify-sizes]', ov);
    var cur = $('.hd-size[aria-checked="true"]', g);
    var email = $('input[type="email"]', form);
    var sizeErr = ntf.sizes.length > 1 && !cur;
    var mailErr = !EMAIL.test(email.value.trim());
    $('[data-hd-notify-size-err]', ov).hidden = !sizeErr;
    $('#hd-ntf-email-msg', ov).hidden = !mailErr;
    email.setAttribute('aria-invalid', mailErr ? 'true' : 'false');
    if (sizeErr || mailErr) { (mailErr ? email : $('.hd-size', g)).focus(); return; }
    var size = cur ? cur.dataset.size : '';
    $('[data-hd-notify-body]', form).value = 'Notify me: ' + ntf.name + (size ? ', size ' + size : '');
    var submit = $('[data-hd-notify-submit]', ov);
    busy(submit, 'Sending');
    sendForm(form).then(function () {
      idle(submit);
      form.hidden = true;
      submit.hidden = true;
      $('[data-hd-notify-close]', ov).hidden = false;
      $('[data-hd-notify-title]', ov).textContent = 'You’re on the list';
      var done = $('[data-hd-notify-done]', ov);
      done.textContent = 'One email to ' + email.value.trim() + ' when ' + ntf.name + (size ? ' in ' + size : '') + ' is back. Nothing else.';
      done.hidden = false;
      $('[data-hd-notify-close]', ov).focus();
    }).catch(function () { idle(submit); HD.toast('Something went wrong on our side. Try again in a minute.', 'error'); });
  });

  /* Invio dei form Shopify (contact, customer) senza lasciare la pagina. */
  var sendForm = HD.sendForm = function (form) {
    return fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'text/html' } }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      if (/challenge/.test(r.url)) { form.submit(); throw new Error('challenge'); }
      return r;
    });
  };

  /* ---------- Request info (Object) ---------- */
  on(doc, 'click', function (e) {
    var b = e.target.closest('[data-hd-info]');
    if (!b) return;
    var ov = doc.getElementById('hd-info');
    $('[data-hd-info-product]', ov).value = b.dataset.hdInfo || '';
    $('[data-hd-info-form]', ov).hidden = false;
    $('[data-hd-info-done]', ov).hidden = true;
    $('[data-hd-info-foot]', ov).hidden = false;
    HD.open('hd-info', b);
  });
  on(doc, 'submit', function (e) {
    var form = e.target.closest('[data-hd-info-form]');
    if (!form) return;
    e.preventDefault();
    var email = $('input[type="email"]', form);
    var bad = !EMAIL.test(email.value.trim());
    $('#hd-info-email-msg').hidden = !bad;
    email.setAttribute('aria-invalid', bad ? 'true' : 'false');
    if (bad) { email.focus(); return; }
    var ov = form.closest('[data-hd-overlay]');
    var btn = $('[form="hd-info-form"]', ov);
    busy(btn, 'Sending');
    sendForm(form).then(function () {
      idle(btn);
      form.hidden = true;
      $('[data-hd-info-foot]', ov).hidden = true;
      var d = $('[data-hd-info-done]', ov);
      d.hidden = false;
      d.setAttribute('tabindex', '-1');
      d.focus();
    }).catch(function () { idle(btn); HD.toast('Something went wrong on our side. Try again in a minute.', 'error'); });
  });

  /* ---------- Newsletter nel footer ---------- */
  on(doc, 'submit', function (e) {
    var form = e.target.closest('[data-hd-news]');
    if (!form) return;
    var email = $('input[type="email"]', form);
    var msg = $('[aria-live]', form);
    if (!EMAIL.test(email.value.trim())) {
      e.preventDefault();
      email.setAttribute('aria-invalid', 'true');
      msg.innerHTML = '<p class="hd-field__msg hd-field__msg--error"><span class="hd-icon hd-icon--alert" aria-hidden="true"></span>Enter a valid email, like name@domain.com.</p>';
      email.focus();
      return;
    }
    e.preventDefault();
    email.removeAttribute('aria-invalid');
    sendForm(form).then(function () {
      msg.innerHTML = '<p class="hd-field__msg hd-field__msg--success"><span class="hd-icon hd-icon--check" aria-hidden="true"></span>You’re in. The key comes by email.</p>';
      form.reset();
    }).catch(function () {
      msg.innerHTML = '<p class="hd-field__msg hd-field__msg--error"><span class="hd-icon hd-icon--alert" aria-hidden="true"></span>Something went wrong on our side. Try again in a minute.</p>';
    });
  });

  /* ---------- Ricerca predittiva (/search/suggest con section_id) ---------- */
  var searchInit = function () {
    var form = $('[data-hd-search]');
    if (!form) return;
    var input = $('input[type="search"]', form);
    var out = $('[data-hd-search-results]');
    var timer, ctrl, active = -1;
    var items = function () { return $$('[data-hd-sr-item]', out); };
    var mark = function (i) {
      var list = items();
      list.forEach(function (a, k) { a.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
      active = i;
      if (list[i]) { input.setAttribute('aria-activedescendant', list[i].id); list[i].scrollIntoView({ block: 'nearest' }); }
      else input.removeAttribute('aria-activedescendant');
    };
    var run = function () {
      var q = input.value.trim();
      if (ctrl) ctrl.abort();
      if (!q) { out.innerHTML = ''; input.setAttribute('aria-expanded', 'false'); return; }
      ctrl = window.AbortController ? new AbortController() : null;
      var url = HD.routes.search + '?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,page,article&resources[limit]=6&section_id=predictive-search';
      fetch(url, ctrl ? { signal: ctrl.signal } : {}).then(function (r) { return r.text(); }).then(function (html) {
        var tmp = doc.createElement('div');
        tmp.innerHTML = html;
        var res = $('[data-hd-sr]', tmp);
        out.innerHTML = res ? res.innerHTML : '';
        input.setAttribute('aria-expanded', items().length ? 'true' : 'false');
        active = -1;
      }).catch(function () {});
    };
    on(input, 'input', function () { clearTimeout(timer); timer = setTimeout(run, 180); });
    on(input, 'keydown', function (e) {
      var n = items().length;
      if (e.key === 'ArrowDown' && n) { e.preventDefault(); mark((active + 1) % n); }
      else if (e.key === 'ArrowUp' && n) { e.preventDefault(); mark((active - 1 + n) % n); }
      else if (e.key === 'Enter' && active >= 0 && items()[active]) { e.preventDefault(); location.href = items()[active].href; }
    });
    on(doc.getElementById('hd-search'), 'hd:open', function () { input.focus(); input.select(); });
  };

  /* ---------- Announcement marquee: fermo con movimento ridotto ---------- */
  var marquee = function () {
    if (!reduce()) return;
    $$('.hd-announce--marquee').forEach(function (b) { b.classList.remove('hd-announce--marquee'); var d = $$('.hd-announce__track', b)[1]; if (d) d.remove(); });
  };

  /* ---------- Avvio ---------- */
  HD.ready = function (fn) { if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', fn); else fn(); };
  HD.ready(function () {
    syncTheme();
    tick();
    setInterval(tick, 15000);
    heroHeader();
    searchInit();
    marquee();
    if (location.hash === '#bag') HD.openCart();
  });
  if (window.Shopify && Shopify.designMode) {
    doc.addEventListener('shopify:section:load', function () { syncTheme(); tick(); heroHeader(); });
  }
})();

/* ---------- Home: schema HUD, nastro delle finiture, banda verticale ---------- */
(function () {
  'use strict';
  var HD = window.HD, $ = HD.$, $$ = HD.$$;
  var fmt = function (n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); };

  /* HUD di Casa Blaster: entra in vista una volta, conta 0 → valore, poi passa da Compact a Stereo. */
  var hud = function (el) {
    if (el.dataset.ready) return;
    el.dataset.ready = '1';
    var nums = $$('.sh-hud__num[data-to]', el);
    var btns = $$('.sh-hud__seg button', el);
    var mode = function (m) {
      el.classList.toggle('is-stereo', m === 'stereo');
      btns.forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.mode === m ? 'true' : 'false'); });
    };
    btns.forEach(function (b) { b.addEventListener('click', function () { mode(b.dataset.mode); }); });
    if (HD.reduce() || !('IntersectionObserver' in window)) { el.classList.add('is-in'); mode('stereo'); return; }
    nums.forEach(function (n) { n.textContent = '0'; });
    var io = new IntersectionObserver(function (es) {
      if (!es.some(function (e) { return e.isIntersecting; })) return;
      io.disconnect();
      el.classList.add('is-in');
      nums.forEach(function (n) {
        var to = Number(n.dataset.to), i = 0, steps = 12;
        var id = setInterval(function () { i++; n.textContent = fmt(i >= steps ? to : Math.round((to * i) / steps)); if (i >= steps) clearInterval(id); }, 55);
      });
      setTimeout(function () { mode('stereo'); }, 900);
    }, { threshold: 0.35 });
    io.observe(el);
  };

  /* Nastro delle finiture: scorre piano (rAF solo quando è in vista), si ferma con hover e focus.
     Touch: si trascina col dito; al rilascio prosegue per inerzia e si ferma con una finitura al centro, selezionata;
     dopo qualche secondo riparte nella direzione dello swipe. Un tocco porta al centro la finitura, il secondo apre il prodotto. */
  var strip = function (sec) {
    if (sec.dataset.ready) return;
    sec.dataset.ready = '1';
    var band = $('.sh-fx', sec), row = $('.sh-fx__row', sec), track = $('.sh-fx__track', sec);
    var label = $('[data-hd-fx-label]', sec), sw = $('[data-hd-fx-sw]', sec), add = $('[data-hd-add]', sec), view = $('[data-hd-fx-view]', sec);
    var paused = false, kb = false, tapType = '', tapSelect = null;
    var select = function (li) {
      $$('.sh-fx__item', sec).forEach(function (x) { x.classList.toggle('is-on', x.dataset.variant === li.dataset.variant); });
      band.classList.add('is-hot');
      if (label.textContent !== li.dataset.label) {
        label.textContent = li.dataset.label;
        label.style.animation = 'none'; void label.offsetWidth; label.style.animation = '';
      }
      if (li.dataset.swatch) sw.style.backgroundImage = 'url(' + li.dataset.swatch + ')';
      add.dataset.hdAdd = li.dataset.variant;
      view.href = li.dataset.url;
    };
    var leave = function () { paused = false; band.classList.remove('is-hot'); $$('.sh-fx__item', sec).forEach(function (x) { x.classList.remove('is-on'); }); };
    var items = $$('.sh-fx__item', sec);
    items.forEach(function (li) {
      var b = $('.sh-fx__btn', li);
      b.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { paused = true; select(li); } });
      b.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') leave(); });
      b.addEventListener('focus', function () {
        try { kb = b.matches(':focus-visible'); } catch (e) { kb = false; }
        if (kb) { paused = true; select(li); }
      });
      b.addEventListener('blur', function () { if (kb) { kb = false; leave(); } });
      b.addEventListener('click', function () {
        var t = tapType;
        tapType = '';
        if (t && t !== 'mouse' && tapSelect && !li.classList.contains('is-on')) { tapSelect(li); return; }
        location.href = li.dataset.url;
      });
    });
    row.addEventListener('pointerdown', function (e) { tapType = e.pointerType; });
    if (HD.reduce()) return;

    var x = 0, v = 0, last = 0, raf = 0, on = true;
    var dir = -1, mode = 'drift', target = 0, holdUntil = 0, cur = null;
    var DRIFT = 30, HOLD = 5000, K = 7;
    var offs = [], half = 0;
    // Per ogni finitura, la x del nastro che la mette al centro della riga.
    var measure = function () {
      var t = track.getBoundingClientRect(), rw = row.clientWidth;
      half = track.scrollWidth / 2;
      offs = items.map(function (li) { var r = li.getBoundingClientRect(); return rw / 2 - (r.left - t.left + r.width / 2); });
    };
    // La finitura più vicina al centro per una data x (tenendo conto del nastro che si ripete).
    var nearest = function (pos, only) {
      var best = null;
      offs.forEach(function (c, i) {
        if (only && items[i] !== only) return;
        var cx = c + Math.round((pos - c) / half) * half, d = Math.abs(cx - pos);
        if (!best || d < best.d) best = { d: d, x: cx, li: items[i] };
      });
      return best;
    };
    var shift = function (d) { x += d; target += d; if (drag) drag.sx += d; };
    var snap = function (li, vel) {
      measure();
      var n = nearest(li ? x : x + vel * 0.35, li);
      target = n.x; v = vel; mode = 'snap'; cur = null;
      band.classList.add('is-hot');
      wake();
    };
    tapSelect = function (li) { snap(li, 0); };

    var step = function (now) {
      var dt = last ? Math.min(0.05, (now - last) / 1000) : 0;
      last = now;
      var w = track.scrollWidth / 2;
      if (mode === 'drift') {
        v += ((paused ? 0 : dir * DRIFT) - v) * Math.min(1, dt * 3.5);
        x += v * dt;
      } else if (mode === 'snap') {
        v += (-K * K * (x - target) - 2 * K * v) * dt;
        x += v * dt;
        if (Math.abs(x - target) < 0.5 && Math.abs(v) < 8) { x = target; v = 0; mode = 'hold'; holdUntil = now + HOLD; }
      } else if (mode === 'hold' && now >= holdUntil) {
        mode = 'drift'; v = 0; leave();
      }
      if (mode === 'drag' || mode === 'snap') {
        var n = offs.length && nearest(x);
        if (n && n.li !== cur) { cur = n.li; select(n.li); }
      }
      if (x <= -w) shift(w); else if (x > 0) shift(-w);
      track.style.transform = 'translate3d(' + x.toFixed(2) + 'px,0,0)';
      raf = on ? requestAnimationFrame(step) : 0;
    };
    var wake = function () { if (on && !raf) { last = 0; raf = requestAnimationFrame(step); } };

    /* Trascinamento col dito (il mouse resta su hover e clic). touch-action: pan-y lascia al browser lo scorrimento verticale. */
    var drag = null, dragged = false;
    row.addEventListener('pointerdown', function (e) {
      dragged = false;
      if (e.pointerType === 'mouse' || !e.isPrimary) return;
      drag = { id: e.pointerId, x0: e.clientX, y0: e.clientY, sx: 0, lx: e.clientX, lt: e.timeStamp, vx: 0, on: false };
    });
    row.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      var dx = e.clientX - drag.x0;
      if (!drag.on) {
        if (Math.abs(dx) < 8 || Math.abs(dx) < Math.abs(e.clientY - drag.y0)) return;
        drag.on = dragged = true;
        drag.sx = x - dx;
        mode = 'drag'; v = 0; cur = null;
        measure();
        band.classList.add('is-hot');
        try { row.setPointerCapture(e.pointerId); } catch (err) {}
        wake();
      }
      var ms = Math.max(1, e.timeStamp - drag.lt);
      drag.vx = drag.vx * 0.5 + ((e.clientX - drag.lx) / ms) * 1000 * 0.5;
      drag.lx = e.clientX; drag.lt = e.timeStamp;
      x = drag.sx + dx;
    });
    var release = function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      var d = drag;
      drag = null;
      if (!d.on) return;
      var vx = e.timeStamp - d.lt > 90 ? 0 : Math.max(-4000, Math.min(4000, d.vx));
      var moved = e.clientX - d.x0;
      dir = Math.abs(vx) > 40 ? (vx > 0 ? 1 : -1) : (moved > 0 ? 1 : -1);
      snap(null, vx);
    };
    row.addEventListener('pointerup', release);
    row.addEventListener('pointercancel', release);
    row.addEventListener('click', function (e) { if (dragged) { dragged = false; tapType = ''; e.preventDefault(); e.stopPropagation(); } }, true);
    row.addEventListener('dragstart', function (e) { e.preventDefault(); });
    new IntersectionObserver(function (es) {
      on = es[0].isIntersecting;
      if (on && !raf) { last = 0; raf = requestAnimationFrame(step); }
    }, { rootMargin: '200px' }).observe(band);
  };

  /* Banda verticale: parallasse con CSS scroll-driven; dove non c'è, IntersectionObserver aggiorna --p. */
  var vband = function (el) {
    if (el.dataset.ready || (window.CSS && CSS.supports('animation-timeline: view()')) || !('IntersectionObserver' in window) || HD.reduce()) return;
    el.dataset.ready = '1';
    el.classList.add('sh-vband--io');
    var th = [];
    for (var i = 0; i <= 40; i++) th.push(i / 40);
    new IntersectionObserver(function (es) {
      var vh = window.innerHeight, r = es[0].boundingClientRect;
      el.style.setProperty('--p', Math.min(1, Math.max(0, (vh - r.top) / (vh + r.height))).toFixed(3));
    }, { threshold: th }).observe(el);
  };

  var init = function () {
    $$('[data-hd-hud]').forEach(hud);
    $$('[data-hd-fx]').forEach(strip);
    $$('[data-hd-vband]').forEach(vband);
  };
  HD.ready(init);
  document.addEventListener('shopify:section:load', init);
})();

/* Pagina password: il campo è sempre visibile; con password sbagliata riceve il focus. */
(function () {
  var input = document.querySelector('.hd-lock__pwinput[aria-invalid="true"]');
  if (input) input.focus();
})();

/* ---------- Pagina prodotto ---------- */
(function () {
  'use strict';
  var HD = window.HD, $ = HD.$, $$ = HD.$$;

  /* Sticky add to bag (mobile): compare quando la CTA della pagina esce dallo schermo. */
  var sticky = function (pdp) {
    var bar = $('[data-hd-sticky]', pdp), watch = $('[data-hd-cta-watch]', pdp);
    if (!bar || !watch || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (es) {
      var out = !es[0].isIntersecting && es[0].boundingClientRect.top < 0;
      bar.classList.toggle('hd-sticky--hidden', !out);
      bar.setAttribute('aria-hidden', out ? 'false' : 'true');
      $$('button,a', bar).forEach(function (b) { b.tabIndex = out ? 0 : -1; });
    }).observe(watch);
  };

  /* Object: swatch delle finiture → foto, prezzo, variante, URL. Zoom 2,2× che segue il mouse, HD al primo passaggio. */
  var object = function (pdp) {
    var group = $('[data-hd-swatches]', pdp);
    var zoom = $('[data-hd-zoom]', pdp);
    var img = $('[data-hd-main-img]', pdp);
    var pick = function (b, focus) {
      var sw = $$('.hd-swatch', group);
      sw.forEach(function (x) { var s = x === b; x.setAttribute('aria-checked', s ? 'true' : 'false'); x.tabIndex = s ? 0 : -1; });
      if (focus) b.focus();
      $('[data-hd-sw-label]', pdp).textContent = b.dataset.title;
      $$('[data-hd-price]', pdp).forEach(function (p) { p.textContent = b.dataset.price; });
      $$('[data-hd-variant-cta]', pdp).forEach(function (c) { c.dataset.hdAdd = b.dataset.variant; c.disabled = b.dataset.available !== 'true'; });
      var n = $('[data-hd-sticky-name]', pdp);
      if (n) n.textContent = n.dataset.base + ', ' + b.dataset.title;
      $$('[data-hd-finish-label]').forEach(function (l) { l.textContent = b.dataset.title; });
      if (img && b.dataset.src) {
        var fresh = img.cloneNode(false);
        fresh.src = b.dataset.src; fresh.srcset = b.dataset.srcset; fresh.alt = b.dataset.alt;
        img.replaceWith(fresh); img = fresh;
        if (zoom) { zoom.dataset.hd = b.dataset.hd; var old = $('.sh-zoom__hd', zoom); if (old) old.remove(); zoom.dataset.asked = ''; }
      }
      try { history.replaceState(null, '', location.pathname + '?variant=' + b.dataset.variant); } catch (e) {}
    };
    if (group) {
      group.addEventListener('click', function (e) { var b = e.target.closest('.hd-swatch'); if (b) pick(b); });
      group.addEventListener('keydown', function (e) {
        var b = e.target.closest('.hd-swatch'); if (!b) return;
        var all = $$('.hd-swatch', group), i = all.indexOf(b), n = all.length, cols = 3, j = null;
        if (e.key === 'ArrowRight') j = (i + 1) % n; else if (e.key === 'ArrowLeft') j = (i - 1 + n) % n;
        else if (e.key === 'ArrowDown') j = Math.min(n - 1, i + cols); else if (e.key === 'ArrowUp') j = Math.max(0, i - cols);
        else if (e.key === 'Home') j = 0; else if (e.key === 'End') j = n - 1;
        if (j === null) return;
        e.preventDefault(); pick(all[j], true);
      });
    }
    if (zoom && window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches) {
      var raf = 0, pt = [0, 0];
      var place = function () {
        raf = 0;
        var r = zoom.getBoundingClientRect();
        var c = function (v) { return Math.max(0, Math.min(100, v)).toFixed(2) + '%'; };
        zoom.style.setProperty('--zx', c((pt[0] - r.left) / r.width * 100));
        zoom.style.setProperty('--zy', c((pt[1] - r.top) / r.height * 100));
      };
      zoom.addEventListener('pointerenter', function (e) {
        if (e.pointerType === 'touch') return;
        pt = [e.clientX, e.clientY]; place();
        zoom.classList.add('is-zoom');
        if (zoom.dataset.hd && !zoom.dataset.asked) {
          zoom.dataset.asked = '1';
          var src = zoom.dataset.hd, im = new Image();
          im.onload = function () {
            if (zoom.dataset.hd !== src) return;
            var hd = document.createElement('img');
            hd.className = 'sh-zoom__hd'; hd.src = src; hd.alt = ''; hd.setAttribute('aria-hidden', 'true');
            zoom.appendChild(hd);
          };
          im.src = src;
        }
      });
      zoom.addEventListener('pointermove', function (e) { if (e.pointerType === 'touch') return; pt = [e.clientX, e.clientY]; if (!raf) raf = requestAnimationFrame(place); });
      zoom.addEventListener('pointerleave', function () { zoom.classList.remove('is-zoom'); });
    }
    sticky(pdp);
  };

  /* By request: galleria a miniature, CTA che portano al form #request, barra fissa quando la CTA è uscita e il form non è in vista. */
  var reserved = function (pdp) {
    var main = $('[data-hd-gal-img]', pdp);
    $$('.sh-gal__thumb', pdp).forEach(function (t) {
      t.addEventListener('click', function () {
        $$('.sh-gal__thumb', pdp).forEach(function (x) { x.setAttribute('aria-pressed', x === t ? 'true' : 'false'); });
        var fresh = main.cloneNode(false);
        fresh.src = t.dataset.src; fresh.srcset = t.dataset.srcset; fresh.alt = t.dataset.alt;
        main.replaceWith(fresh); main = fresh;
      });
    });
    var bar = $('[data-hd-st-bar]', pdp), cta = $('[data-hd-cta-watch]', pdp), form = document.getElementById('request');
    if (bar && cta && 'IntersectionObserver' in window) {
      var ctaOut = false, formIn = false;
      var upd = function () { var onb = ctaOut && !formIn; bar.classList.toggle('is-on', onb); bar.setAttribute('aria-hidden', onb ? 'false' : 'true'); $('a', bar).tabIndex = onb ? 0 : -1; };
      new IntersectionObserver(function (es) { ctaOut = !es[0].isIntersecting && es[0].boundingClientRect.top < 0; upd(); }).observe(cta);
      if (form) new IntersectionObserver(function (es) { formIn = es[0].isIntersecting; upd(); }, { rootMargin: '0px 0px -30% 0px' }).observe(form);
    }
    document.body.appendChild(bar);
  };
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-hd-to-request]');
    if (!a) return;
    var el = document.getElementById('request');
    if (!el) return;
    e.preventDefault();
    window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 72, behavior: HD.reduce() ? 'auto' : 'smooth' });
    setTimeout(function () { var f = document.getElementById('st-name'); if (f) f.focus({ preventScroll: true }); }, HD.reduce() ? 0 : 600);
  });

  /* Merch: taglia → CTA ("Add M to bag", "Notify me, M", "Select a size"), nota di stock solo sulla taglia scelta. */
  var merch = function (pdp) {
    var side = $('[data-hd-merch-pdp]', pdp);
    var wrap = $('[data-hd-mp-cta]', pdp);
    var stickyWrap = $('[data-hd-sticky-merch]', pdp);
    var label = $('[data-hd-size-label]', pdp);
    var note = $('.hd-stock', side);
    var render = function () {
      var sel = $('.hd-size[aria-checked="true"]', side);
      var allOut = side.dataset.allOut === 'true';
      var stock = sel && sel.dataset.stock !== '' ? Number(sel.dataset.stock) : null;
      var html, sHtml;
      label.innerHTML = sel ? ': <span class="sh-mp-val">' + sel.dataset.size + '</span>' : '';
      note.textContent = sel && stock !== null ? HD.stockNote(stock, sel.dataset.size) : '';
      if ((!sel && allOut) || (sel && stock === 0)) {
        var t = sel ? 'Notify me, ' + sel.dataset.size : 'Notify me';
        html = '<button class="hd-btn hd-btn--primary hd-btn--block" type="button" data-mode="notify"><span class="hd-btn__label"><span class="hd-icon hd-icon--bell" aria-hidden="true"></span>' + t + '</span></button>';
        sHtml = html.replace('type="button"', 'type="button" data-sticky');
      } else if (!sel) {
        html = '<button class="hd-btn hd-btn--secondary hd-btn--block" type="button" disabled data-mode=""><span class="hd-btn__label">Select a size</span></button>';
        sHtml = '<button class="hd-btn hd-btn--secondary hd-btn--block" type="button" data-mode="to-sizes"><span class="hd-btn__label">Select a size</span></button>';
      } else {
        html = '<button class="hd-btn hd-btn--primary hd-btn--block hd-btn--split" type="button" data-hd-add="' + sel.dataset.variant + '" data-added-label="Added to bag, ' + sel.dataset.size + '"><span class="hd-btn__label">Add ' + sel.dataset.size + ' to bag</span><span class="hd-btn__meta">' + side.dataset.price + '</span></button>';
        sHtml = html;
      }
      wrap.firstElementChild.outerHTML = html;
      if (stickyWrap) {
        var hidden = $('[data-hd-sticky]', pdp).classList.contains('hd-sticky--hidden');
        stickyWrap.innerHTML = sHtml;
        $$('button', stickyWrap).forEach(function (b) { b.tabIndex = hidden ? -1 : 0; });
      }
    };
    side.addEventListener('hd:size', render);
    pdp.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-mode]');
      if (!b) return;
      if (b.dataset.mode === 'notify') { var sel = $('.hd-size[aria-checked="true"]', side); HD.notify(side, sel ? sel.dataset.size : ''); }
      if (b.dataset.mode === 'to-sizes') { var g = $('.hd-sizes', side); window.scrollTo({ top: g.getBoundingClientRect().top + window.scrollY - 200, behavior: HD.reduce() ? 'auto' : 'smooth' }); var f = $('.hd-size', g); if (f) f.focus({ preventScroll: true }); }
    });
    sticky(pdp);
  };

  var init = function () {
    $$('[data-hd-pdp]').forEach(function (pdp) {
      if (pdp.dataset.ready) return;
      pdp.dataset.ready = '1';
      var mode = pdp.dataset.mode;
      if (mode === 'object') object(pdp);
      else if (mode === 'reserved') reserved(pdp);
      else merch(pdp);
    });
  };
  HD.ready(init);
  document.addEventListener('shopify:section:load', init);
})();

/* ---------- Manifesto (Read the full text) e Request access ---------- */
(function () {
  'use strict';
  var HD = window.HD, $ = HD.$, $$ = HD.$$;
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-hd-more]');
    if (!b) return;
    var box = document.getElementById(b.getAttribute('aria-controls'));
    var open = box.hidden;
    box.hidden = !open;
    b.setAttribute('aria-expanded', open ? 'true' : 'false');
    b.textContent = open ? 'Show less' : 'Read the full text';
  });
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-hd-request]');
    if (!form) return;
    e.preventDefault();
    var val = function (id) { var el = document.getElementById(id); return el ? el.value.trim() : ''; };
    var errs = {
      'st-name': !val('st-name'),
      'st-email': !HD.EMAIL.test(val('st-email')),
      'st-country': !val('st-country'),
      'st-consent': !document.getElementById('st-consent').checked
    };
    var first = null;
    Object.keys(errs).forEach(function (id) {
      var el = document.getElementById(id), msg = document.getElementById(id + '-msg');
      if (msg) msg.hidden = !errs[id];
      el.setAttribute('aria-invalid', errs[id] ? 'true' : 'false');
      if (errs[id] && !first) first = el;
    });
    if (first) { first.focus(); return; }
    var btn = $('button[type="submit"]', form);
    HD.btn.busy(btn, 'Sending');
    HD.sendForm(form).then(function () {
      var done = $('[data-hd-request-done]', form.parentNode);
      var space = (form.querySelector('input[name="contact[space]"]:checked') || {}).value || '';
      $('[data-k="email"]', done).textContent = val('st-email');
      $('[data-k="name"]', done).textContent = val('st-name');
      $('[data-k="country"]', done).textContent = val('st-country');
      if (space) { $('[data-k="space"]', done).textContent = space; $('[data-k="space"]', done).hidden = false; $('[data-k-space]', done).hidden = false; }
      form.hidden = true;
      done.hidden = false;
      done.focus();
    }).catch(function () { HD.btn.idle(btn); HD.toast('Something went wrong on our side. Try again in a minute.', 'error'); });
  });
})();

/* ---------- About: ritratto con profondità ---------- */
(function () {
  'use strict';
  var HD = window.HD;
  var depth = function (el) {
    if (el.dataset.ready) return;
    el.dataset.ready = '1';
    var fine = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (!fine) {
      if (!('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { el.classList.add('is-focus'); io.disconnect(); } }, { threshold: 0.55 });
      io.observe(el);
      return;
    }
    var raf = 0, tx = 0, ty = 0;
    var paint = function () { raf = 0; el.style.setProperty('--dx', tx.toFixed(3)); el.style.setProperty('--dy', ty.toFixed(3)); };
    var queue = function () { if (!raf) raf = requestAnimationFrame(paint); };
    el.addEventListener('pointerenter', function () { el.classList.add('is-focus'); });
    el.addEventListener('pointermove', function (e) {
      if (HD.reduce()) return;
      var r = el.getBoundingClientRect();
      tx = ((e.clientX - r.left) / r.width - 0.5) * 2;
      ty = ((e.clientY - r.top) / r.height - 0.5) * 2;
      queue();
    });
    el.addEventListener('pointerleave', function () { el.classList.remove('is-focus'); tx = 0; ty = 0; queue(); });
  };
  var init = function () { HD.$$('[data-hd-depth]').forEach(depth); };
  HD.ready(init);
  document.addEventListener('shopify:section:load', init);
})();

/* Link interni con scorrimento morbido (es. hero della landing → #buy). */
document.addEventListener('click', function (e) {
  var a = e.target.closest('a[data-hd-scroll][href^="#"]');
  if (!a) return;
  var el = document.getElementById(a.getAttribute('href').slice(1));
  if (!el) return;
  e.preventDefault();
  window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 72, behavior: window.HD.reduce() ? 'auto' : 'smooth' });
});

/* ---------- Intro loader: sequenza 1,2 s (figura 144P → HD a 1 bit, segni a registro, contatore 0 → 100%) ---------- */
(function () {
  'use strict';
  var HD = window.HD;
  var el = document.querySelector('[data-hd-intro]');
  if (!el || el.hidden) return;
  var RES = [[12, '144P'], [24, '240P'], [56, '480P'], [0, 'HD']];
  var DRIFT = [18, 12, 6, 0];
  var COUNT = [0, 4, 11, 23, 38, 57, 64, 79, 91, 100];
  var fig = el.querySelector('.hd-intro__fig'), canvas = fig.querySelector('canvas'), resEl = el.querySelector('.hd-intro__res');
  var status = el.querySelector('.hd-intro__status'), count = el.querySelector('.hd-intro__count span'), ticks = el.querySelectorAll('.hd-intro__ticks i');
  var marks = el.querySelectorAll('.hd-intro__mark');
  var img = null, res = 0, timers = [], done = false;
  var later = function (fn, ms) { timers.push(setTimeout(fn, ms)); };
  var draw = function () {
    if (!img) return;
    var dpr = Math.min(2, window.devicePixelRatio || 1), cw = Math.max(1, Math.round(fig.clientWidth * dpr)), ch = Math.max(1, Math.round(fig.clientHeight * dpr));
    canvas.width = cw; canvas.height = ch;
    var ctx = canvas.getContext('2d'), rows = RES[res][0];
    if (!rows) { ctx.drawImage(img, 0, 0, cw, ch); return; }
    var sh = rows, sw = Math.max(2, Math.round(rows * cw / ch));
    var off = document.createElement('canvas'); off.width = sw; off.height = sh;
    var o = off.getContext('2d'); o.drawImage(img, 0, 0, sw, sh);
    var px = o.getImageData(0, 0, sw, sh);
    for (var i = 3; i < px.data.length; i += 4) px.data[i] = px.data[i] > 110 ? 255 : 0;
    o.putImageData(px, 0, 0);
    ctx.imageSmoothingEnabled = false;
    ctx.drawImage(off, 0, 0, sw, sh, 0, 0, cw, ch);
  };
  var setStep = function (i, held) {
    var pct = COUNT[i];
    res = held ? RES.length - 1 : Math.min(RES.length - 1, Math.floor(i / 2.5));
    count.textContent = pct;
    var lit = Math.round(pct / 100 * 60);
    for (var k = 0; k < ticks.length; k++) ticks[k].classList.toggle('on', lit > 0 && k <= lit);
    resEl.textContent = 'Res; ' + RES[res][1];
    var d = DRIFT[res];
    for (var m = 0; m < marks.length; m++) marks[m].style.transform = 'translate(' + (marks[m].dataset.sx * d) + 'px,' + (marks[m].dataset.sy * d) + 'px)';
    status.textContent = held ? status.dataset.done : status.dataset.status;
    draw();
  };
  var finish = function () {
    if (done) return;
    done = true;
    timers.forEach(clearTimeout);
    try { sessionStorage.setItem('hd-intro', '1'); } catch (e) {}
    el.remove();
    document.documentElement.classList.remove('hd-intro-on');
  };
  var exit = function () {
    if (done) return;
    timers.forEach(clearTimeout); timers = [];
    setStep(COUNT.length - 1, true);
    el.classList.add('hd-intro--out');
    later(finish, 260);
  };
  el.addEventListener('click', exit);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') exit(); });
  fetch(el.dataset.fig).then(function (r) { return r.text(); }).then(function (svg) {
    var color = getComputedStyle(el).color;
    var im = new Image();
    im.onload = function () { img = im; draw(); };
    im.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg.replace(/currentColor/g, color));
  }).catch(function () {});
  if ('ResizeObserver' in window) new ResizeObserver(draw).observe(fig);
  HD.ready(function () {
    if (HD.reduce()) { setStep(COUNT.length - 1, true); later(exit, 700); return; }
    COUNT.forEach(function (_, i) { later(function () { setStep(i, false); }, i * 72); });
    later(function () { setStep(COUNT.length - 1, true); }, 720);
    later(exit, 920);
  });
})();

/* ---------- Menu a tendina del sito: sostituisce select.hd-select (il select resta nascosto e sincronizzato per il form) ---------- */
(function () {
  'use strict';
  var HD = window.HD, $ = HD.$, $$ = HD.$$;
  var n = 0;
  var openDd = null;
  var enhance = function (sel) {
    if (sel.dataset.dd) return;
    sel.dataset.dd = '1';
    var wrap = sel.closest('.hd-select-wrap') || sel.parentNode;
    var id = (sel.id || 'hd-sel-' + (++n));
    var dd = document.createElement('div');
    dd.className = 'hd-dd';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'hd-dd__btn';
    btn.id = id + '-dd';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', id + '-list');
    btn.innerHTML = '<span class="hd-dd__val"></span><span class="hd-icon hd-icon--chevron-down" aria-hidden="true"></span>';
    var list = document.createElement('ul');
    list.className = 'hd-dd__list';
    list.id = id + '-list';
    list.setAttribute('role', 'listbox');
    list.tabIndex = -1;
    list.hidden = true;
    var label = sel.id ? document.querySelector('label[for="' + sel.id + '"]') : null;
    if (label) { if (!label.id) label.id = id + '-label'; list.setAttribute('aria-labelledby', label.id); btn.setAttribute('aria-labelledby', label.id + ' ' + btn.id); label.htmlFor = btn.id; }
    var opts = Array.prototype.slice.call(sel.options).filter(function (o) { return !o.disabled; });
    var placeholder = Array.prototype.slice.call(sel.options).find(function (o) { return o.disabled && o.value === ''; });
    opts.forEach(function (o, i) {
      var li = document.createElement('li');
      li.className = 'hd-dd__opt';
      li.id = id + '-opt-' + i;
      li.setAttribute('role', 'option');
      li.dataset.value = o.value;
      li.innerHTML = '<span></span>';
      li.firstChild.textContent = o.textContent;
      list.appendChild(li);
    });
    var items = $$('.hd-dd__opt', list);
    var active = -1;
    var sync = function () {
      var val = sel.value, txt = '';
      items.forEach(function (li) { var s = li.dataset.value === val && val !== ''; li.setAttribute('aria-selected', s ? 'true' : 'false'); if (s) txt = li.firstChild.textContent; });
      if (!txt && sel.selectedIndex >= 0 && !(sel.options[sel.selectedIndex] || {}).disabled) txt = sel.options[sel.selectedIndex].textContent;
      var v = $('.hd-dd__val', btn);
      v.textContent = txt || (placeholder ? placeholder.textContent : '');
      v.classList.toggle('is-empty', !txt);
    };
    var mark = function (i) {
      items.forEach(function (li, k) { li.classList.toggle('is-active', k === i); });
      active = i;
      if (items[i]) { list.setAttribute('aria-activedescendant', items[i].id); items[i].scrollIntoView({ block: 'nearest' }); }
    };
    var body = sel.closest('.hd-overlay__body');
    var open = function () {
      if (openDd && openDd !== close) openDd();
      list.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      if (body) body.classList.add('is-dd-open');
      var r = btn.getBoundingClientRect();
      dd.classList.toggle('hd-dd--up', r.bottom + Math.min(360, list.scrollHeight) + 8 > window.innerHeight && r.top > window.innerHeight - r.bottom);
      var cur = items.findIndex(function (li) { return li.getAttribute('aria-selected') === 'true'; });
      mark(cur >= 0 ? cur : 0);
      list.focus({ preventScroll: true });
      openDd = close;
    };
    var close = function (refocus) {
      if (list.hidden) return;
      list.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
      if (body) body.classList.remove('is-dd-open');
      if (openDd === close) openDd = null;
      if (refocus) btn.focus();
    };
    var choose = function (i) {
      if (!items[i]) return;
      sel.value = items[i].dataset.value;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      sync();
      close(true);
    };
    btn.addEventListener('click', function () { if (list.hidden) open(); else close(true); });
    btn.addEventListener('keydown', function (e) {
      if (['ArrowDown', 'ArrowUp', 'Enter', ' '].indexOf(e.key) >= 0) { e.preventDefault(); open(); }
    });
    list.addEventListener('click', function (e) { var li = e.target.closest('.hd-dd__opt'); if (li) choose(items.indexOf(li)); });
    list.addEventListener('mousemove', function (e) { var li = e.target.closest('.hd-dd__opt'); if (li) mark(items.indexOf(li)); });
    var typed = '', typedAt = 0;
    list.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); mark(Math.min(items.length - 1, active + 1)); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); mark(Math.max(0, active - 1)); }
      else if (e.key === 'Home') { e.preventDefault(); mark(0); }
      else if (e.key === 'End') { e.preventDefault(); mark(items.length - 1); }
      else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); choose(active); }
      else if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); close(true); }
      else if (e.key === 'Tab') { close(false); }
      else if (e.key.length === 1) {
        var now = Date.now();
        typed = (now - typedAt > 600 ? '' : typed) + e.key.toLowerCase();
        typedAt = now;
        var j = items.findIndex(function (li) { return li.firstChild.textContent.toLowerCase().indexOf(typed) === 0; });
        if (j >= 0) mark(j);
      }
    });
    document.addEventListener('click', function (e) { if (!dd.contains(e.target)) close(false); });
    // Stato d'errore e focus dal codice di validazione: il select nascosto rimanda al bottone.
    new MutationObserver(function () {
      var inv = sel.getAttribute('aria-invalid');
      if (inv) btn.setAttribute('aria-invalid', inv); else btn.removeAttribute('aria-invalid');
    }).observe(sel, { attributes: true, attributeFilter: ['aria-invalid'] });
    sel.focus = function () { btn.focus(); };
    var desc = sel.getAttribute('aria-describedby');
    if (desc) btn.setAttribute('aria-describedby', desc);
    sel.classList.add('hd-vh');
    sel.tabIndex = -1;
    sel.setAttribute('aria-hidden', 'true');
    var chev = wrap.querySelector(':scope > .hd-icon');
    if (chev) chev.remove();
    dd.appendChild(btn);
    dd.appendChild(list);
    wrap.appendChild(dd);
    sel.addEventListener('change', sync);
    sync();
  };
  var init = function () { $$('select.hd-select').forEach(enhance); };
  HD.ready(init);
  document.addEventListener('shopify:section:load', init);
})();
